import { FormEnginePlugin } from '@form-engine/core-application';
import { CompileableObjectDefinition } from '@form-engine/core-util/create-object';
import { CompileRequestContentTypes } from '@form-engine/core-util/request';
import { apiName } from './workflow-layers/http-request';
import WorkflowLayer from './workflow-layers/http-request/client';

declare module '@form-engine/core-application/types/form' {
    interface WorkflowLayerDefinitionSubType {
        [apiName]: {
            url?: string;
            method?: 'GET' | 'POST' | 'PUT' | 'PATCH' | 'DELETE';
            contentType?: CompileRequestContentTypes;
            responseType?: '' | 'text/plain' | 'application/json';
            body?: string | CompileableObjectDefinition;
            storeResultAs?: string;
            storeErrorAs?: string;
        } & AuthInfo;
    }
}

export default {
    workflowLayers: {
        [WorkflowLayer.apiName]: WorkflowLayer,
    },
} as FormEnginePlugin;
